import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import type { ImportOrderFormData } from '#features/csvImport/ImportOrderFormValidation.ts';

import { ControlledNumberFormInput } from '../../form/FormInput.tsx';
import type { OrderFormData } from './OrderFormValidation.ts';

type CargoMaterialFieldsProps = {
    materialPrefix: `orders.${number}.materials.${number}` | `materials.${number}`;
};

export const CargoLoadMetricFields = ({ materialPrefix }: CargoMaterialFieldsProps) => {
    const { control } = useFormContext<OrderFormData | ImportOrderFormData>();
    const intl = useIntl();

    return (
        <div className='display-flex align-items-center gap-20'>
            <ControlledNumberFormInput
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.freight.weight',
                    defaultMessage: 'Weight',
                })}
                formGroupClassName='flex-1-1-0'
                name={`${materialPrefix}.weight`}
                className='flex-1-1-0'
                addon='kg'
                control={control}
            />
            <ControlledNumberFormInput
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.material.loading-meter',
                    defaultMessage: 'Loading meter',
                })}
                formGroupClassName='flex-1-1-0'
                name={`${materialPrefix}.loadingMeter`}
                className='flex-1-1-0'
                addon='Ldm'
                control={control}
            />
        </div>
    );
};

export const CargoDimensionFields = ({ materialPrefix }: CargoMaterialFieldsProps) => {
    const { control } = useFormContext<OrderFormData | ImportOrderFormData>();
    const intl = useIntl();

    return (
        <div className='display-flex align-items-center gap-20'>
            <ControlledNumberFormInput
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.freight.length',
                    defaultMessage: 'Length',
                })}
                formGroupClassName='flex-1-1-0'
                name={`${materialPrefix}.length`}
                className='flex-1-1-0'
                addon='cm'
                control={control}
            />

            <ControlledNumberFormInput
                formGroupClassName='flex-1-1-0'
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.freight.width',
                    defaultMessage: 'Width',
                })}
                name={`${materialPrefix}.width`}
                className='no-controls flex-1-1-0'
                addon='cm'
                control={control}
            />

            <ControlledNumberFormInput
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.freight.height',
                    defaultMessage: 'Height',
                })}
                formGroupClassName='flex-1-1-0'
                name={`${materialPrefix}.height`}
                className='flex-1-1-0'
                addon='cm'
                control={control}
            />
        </div>
    );
};
